// Shop logo configuration for common book retailers
export interface ShopLogoConfig {
  name: string
  logo: string
  color: string
  favicon?: string
  isLocal?: boolean
}

// SVG logos as data URIs for common shops
export const shopLogos: Record<string, ShopLogoConfig> = {
  amazon: {
    name: 'Amazon',
    logo: 'data:image/svg+xml;base64,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',
    color: '#FF9900',
    favicon: 'https://www.amazon.de/favicon.ico'
  },
  thalia: {
    name: 'Thalia',
    logo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iNCIgZmlsbD0iI0U5MDAyMCIvPgo8cGF0aCBkPSJNOCA3SDEzVjlIOVYxN0g3VjlIM1Y3SDhWN1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xNCAxN1YxNUgxOVYxN0gxNFoiIGZpbGw9id2hpdGUiLz4KPC9zdmc+',
    color: '#E90020',
    favicon: 'https://www.thalia.de/favicon.ico'
  },
  hugendubel: {
    name: 'Hugendubel',
    logo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iNCIgZmlsbD0iIzAwM0Q2RCIvPgo8cGF0aCBkPSJNNiA4SDhWMTBIMTBWOEgxMlYxNkgxMFYxMkg4VjE2SDZWOFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xNCA4SDE4VjEwSDE2VjE2SDE0VjhaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4=',
    color: '#003D6D',
    favicon: 'https://www.hugendubel.de/favicon.ico'
  },
  weltbild: {
    name: 'Weltbild',
    logo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iNCIgZmlsbD0iI0ZGNjgwMCIvPgo8cGF0aCBkPSJNMTIgNUMxNS44NjYgNSAxOSA4LjEzNCAxOSAxMkMxOSAxNS44NjYgMTUuODY2IDE5IDEyIDE5QzguMTM0IDE5IDUgMTUuODY2IDUgMTJDNSA4LjEzNCA4LjEzNCA1IDEyIDVaTTEyIDdDOS4yMzkgNyA3IDkuMjM5IDcgMTJDNyAxNC43NjEgOS4yMzkgMTcgMTIgMTdDMTQuNzYxIDE3IDE3IDE0Ljc2MSAxNyAxMkMxNyA5LjIzOSAxNC43NjEgNyAxMiA3WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTEyIDlDMTMuNjU3IDkgMTUgMTAuMzQzIDE1IDEyQzE1IDEzLjY1NyAxMy42NTcgMTUgMTIgMTVDMTAuMzQzIDE1IDkgMTMuNjU3IDkgMTJDOSAxMC4zNDMgMTAuMzQzIDkgMTIgOVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPg==',
    color: '#FF6800',
    favicon: 'https://www.weltbild.de/favicon.ico'
  },
  osiander: {
    name: 'Osiander',
    logo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iNCIgZmlsbD0iIzAwNjZDQyIvPgo8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSI1IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9Im5vbmUiLz4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+',
    color: '#0066CC',
    favicon: 'https://www.osiander.de/favicon.ico'
  },
  buecher: {
    name: 'Bücher.de',
    logo: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iNCIgZmlsbD0iI0VBMDAwMCIvPgo8cGF0aCBkPSJNNiA3SDEwQzExLjEwNDYgNyAxMiA3Ljg5NTQzIDEyIDlWMTBDMTIgMTEuMTA0NiAxMS4xMDQ2IDEyIDEwIDEySDhWMTdINlY3WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTggOVYxMEgxMFY5SDhaIiBmaWxsPSIjRUEwMDAwIi8+CjxwYXRoIGQ9Ik0xNCAxMVYxN0gxNlYxMUgxNFoiIGZpbGw9IndoaXRlIi8+CjxjaXJjbGUgY3g9IjE1IiBjeT0iOCIgcj0iMSIgZmlsbD0id2hpdGUiLz4KPC9zdmc+',
    color: '#EA0000',
    favicon: 'https://www.buecher.de/favicon.ico'
  },
  'lokaler buchhändler': {
    name: 'Lokaler Buchhändler',
    logo: '',
    color: '#10B981',
    isLocal: true
  },
  'lokaler händler': {
    name: 'Lokaler Händler',
    logo: '',
    color: '#10B981',
    isLocal: true
  }
}

// Get shop config by name (case-insensitive)
export function getShopConfig(shopName: string): ShopLogoConfig | null {
  const normalizedName = shopName.toLowerCase().trim()
  
  // Check exact matches first
  if (shopLogos[normalizedName]) {
    return shopLogos[normalizedName]
  }
  
  // Check if the name contains any of the shop names
  for (const [key, config] of Object.entries(shopLogos)) {
    if (normalizedName.includes(key) || key.includes(normalizedName)) {
      return config
    }
  }
  
  // Check for local shop keywords
  if (normalizedName.includes('lokal') || normalizedName.includes('local')) {
    return {
      name: shopName,
      logo: '',
      color: '#10B981',
      isLocal: true
    }
  }
  
  return null
}

// Get shop logo URL
export function getShopLogo(shopName: string): string | null {
  const config = getShopConfig(shopName)
  return config?.logo || null
}

// Check if shop is local
export function isLocalShop(shopName: string): boolean {
  const config = getShopConfig(shopName)
  return config?.isLocal || false
}

// Get shop color
export function getShopColor(shopName: string): string {
  const config = getShopConfig(shopName)
  return config?.color || '#6B7280'
}